export const GET_FILTERS_NUMBER_OF_MENTIONS = 'GET_FILTERS_NUMBER_OF_MENTIONS';

export function getFiltersNumberOfMentions(mentions) {
  return {
    type: GET_FILTERS_NUMBER_OF_MENTIONS,
    data: mentions,
  };
}
